import { lazy } from 'react'
import { Route, Routes } from 'react-router-dom'
import MainLayout from '../layouts/MainLayout';

const HomePage = lazy(() => import("../pages/HomePage"));
const CategoryPage = lazy(() => import("../pages/CategoryPage"));
const DishPage = lazy(() => import("../pages/DishPage"));
const AboutUsPage = lazy(() => import("../pages/AboutUsPage"));
const ConstructorPage = lazy(() => import("../pages/ConstructorPage"));
const CollagenPage = lazy(() => import("../pages/CollagenPage"));
const CoffePage = lazy(() => import("../pages/CoffePage"));
const TeaPage = lazy(() => import("../pages/TeaPage"));
const DrinksPage = lazy(() => import("../pages/DrinksPage"));
const BarPage = lazy(() => import("../pages/BarPage"));
const SmuziPage = lazy(() => import("../pages/SmuziPage"));
const WinePage = lazy(() => import("../pages/WinePage"));
const DiscountPage = lazy(() => import("../pages/DiscountPage"));
const ImmunityPage = lazy(() => import("../pages/ImmunityPage"));



function MainRoutes() {
    return (
        <Routes>
            <Route element={<MainLayout />}>
                <Route path='/' element={<HomePage />} />
                <Route path='/categories' element={<CategoryPage />} />
                <Route path='/dish/:id' element={<DishPage />} />
                <Route path='/about' element={<AboutUsPage />} />
                <Route path='/constructor' element={<ConstructorPage />} />
                <Route path='/collagen' element={<CollagenPage />} />
                <Route path='/categories/collagen' element={<CollagenPage />} />
                <Route path='/categories/coffe' element={<CoffePage />} />
                <Route path='/categories/tea' element={<TeaPage />} />
                <Route path='/categories/drinks' element={<DrinksPage />} />
                <Route path='/categories/bar' element={<BarPage />} />
                <Route path='/categories/smuzie' element={<SmuziPage />} />
                <Route path='/wine' element={<WinePage />} />
                <Route path='/categories/wine' element={<WinePage />} />
                <Route path='/dish/22' element={<DiscountPage />} />
                <Route path='/immunity' element={<ImmunityPage />} />
            </Route>
        </Routes>
    )
}

export default MainRoutes